module.exports = __webpack_public_path__ + "static/media/designPatent_30-1028637.54733aba.png";